import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import FundraisingDetailsPageContext from "./FundraisingDetailsPageContext";

const useFundraisingDetailsPageContext = () =>
  useDefinedContext(FundraisingDetailsPageContext, "FundraisingDetailsPageContext");

export default useFundraisingDetailsPageContext;
